import { __assign } from "tslib";
import React from 'react';
import classNames from 'classnames';
import styles from './hashtag.scss';
var Hashtag = function (props) {
    var _a;
    var children = props.children, decoratedText = props.decoratedText, createHref = props.createHref, onClick = props.onClick, _b = props.target, target = _b === void 0 ? '_self' : _b, _c = props.theme, theme = _c === void 0 ? {} : _c;
    var text = decoratedText.slice(1);
    var href = createHref ? createHref(text) : null;
    var Component = href ? 'a' : 'span';
    var className = classNames(href && 'hashtag-link', styles.hashtag, theme && theme.hashtag, (_a = {},
        _a[styles.hashtag_hover] = !!href,
        _a[theme.hashtag_hover] = theme && theme.hashtag_hover && !!href,
        _a));
    var decoratedOnClick = onClick ? function (event) { return onClick(event, text); } : null;
    var cProps = href
        ? { className: className, href: href, target: target, onClick: decoratedOnClick }
        : { className: className };
    return (
    // @ts-ignore
    React.createElement(Component, __assign({}, cProps), React.Children.toArray(children).some(function (child) { return child['type'] === 'span'; }) ? (children) : (React.createElement("span", null, children))));
};
export default Hashtag;
//# sourceMappingURL=HashtagComponent.js.map